import styled from 'styled-components';

import { Help as HelpOriginal } from '@ovpn-ui/icons';

export const Help = styled(HelpOriginal)`
    &&&& {
        width: 16px;
        height: 16px;

        stroke-width: 2px;
    }

    margin: -5px 0 -4px 4px;
`;

export const NoWrapSpan = styled.span`
    white-space: nowrap;
`;

export const DefaultWrapper = styled.div<{ $display?: string }>`
    display: ${t => t.$display};
    width: 100%;

    word-break: keep-all;
`;
